import { useTheme } from '@mui/material/styles';
import { Badge, Tooltip, Box } from '@mui/material';
import { SwapOutlined } from '@ant-design/icons';
import IconButton from 'components/@extended/IconButton';
import useAuth from 'hooks/useAuth';
import CustomTooltip from 'components/CustomTooltip';

const ImpersonationBanner = () => {
  const theme = useTheme();
  const { user, isImpersonating, stopImpersonation } = useAuth();

  if (!isImpersonating()) return null;

  return (
    <Box sx={{ flexShrink: 0, ml: 0.75 }}>
      <CustomTooltip title={`Logged in as ${user?.email}, click to return to your personal account`}>
        <IconButton
          color="warning"
          variant="light"
          onClick={stopImpersonation}
        >
          <Badge variant="dot" color="warning">
            <SwapOutlined />
          </Badge>
        </IconButton>
      </CustomTooltip>
    </Box>
  );
};

export default ImpersonationBanner;
